import { useQueryClient } from '@tanstack/react-query'

export const useGetFromQueryCache = <T>({ data, queryKey }: { data: T; queryKey: unknown[] | unknown }): T => {
  const client = useQueryClient()
  const [cachedData] = client.getQueriesData<T>(queryKey)

  return data ?? (cachedData && cachedData[1])
}
